import * as React from 'react';
import { ModalCloseButton } from "./ModalCloseButton";
import ModalDialog from './ModalDialog';

class ModalDialogWarning extends React.Component {
    constructor(props) {
        super(props);
        this.state = { message: '' };
    }

    render() {
        return <ModalDialog id={this.props.id}
            title="Warning"
            bodyMessage={this.props.message}
            //iconName='alert'
            //titleClassName='text-warning'
            className={this.props.className}
            footerChild={(
                <div>
                    <ModalCloseButton id={'warningModalCloseButton_' + this.props.id} value='Close' />
                </div>
            )}>
        </ModalDialog >;
    }
}

export default ModalDialogWarning;


// WEBPACK FOOTER //
// ./src/components/Controls/ModalDialogWarning.js